import { TextBadge, TooltipBubble } from '@carboncopyco/ui';
import React from 'react';

export const GuidanceManagerSectionHeader = ({ label }: { label: string }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  return (
    <>
      <div
        className="flex w-full mt-2 mb-3"
        ref={ref}
      >
        <TextBadge
          label={label}
          ellipsis
        />
      </div>
      <TooltipBubble
        placement="top"
        width={240}
        title={label}
        anchorRef={ref}
      />
    </>
  );
};
